module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 11 21",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }